export default __webpack_public_path__ + "static/media/iOS.29cf564c.svg";